import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { HorizontalScrollRow } from '@/ui/common';
import { HOME_MENU_ITEMS } from './home-menu-config';
import { HomeMenuButton } from './HomeMenuButton';

export interface HomeMainMenuProps {
  className?: string;
}

/**
 * Figma HomeMainMenu / Mobile — horizontal product-tile rail on the homepage.
 */
export function HomeMainMenu({ className }: HomeMainMenuProps) {
  const { t } = useTranslation();

  return (
    <HorizontalScrollRow
      aria-label={t('Main menu', { defaultValue: 'Main menu' })}
      withDesktopArrows
      className={cn('gap-2.5 pl-0', className)}
    >
      {HOME_MENU_ITEMS.map((item) => (
        <div key={item.id} role="listitem">
          <HomeMenuButton item={item} />
        </div>
      ))}
    </HorizontalScrollRow>
  );
}
